import React from 'react';
import { Badge, Box, Typography, IconButton, Stack } from '@mui/material';
import { FilterList as FilterIcon } from '@mui/icons-material';
import SearchField from './SearchField';
import useBrand from '../styles/theme/brands/useBrand';

const TopBar = ({
  title,
  showFilter = false,
  onFilterClick,
  activeFilterCount = 0,
  showSearch = false,
  onSearch,
  searchPlaceholder,
  searchFooter,
  actions,
}) => {
  const { name, logo } = useBrand();
  const hasActive = activeFilterCount > 0;

  return (
    <Box
      sx={(theme) => ({
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bgcolor: 'background.paper',
        zIndex: 1300,
        paddingTop: '16px',
        paddingBottom: '16px',
        paddingX: '16px',
        boxShadow: 1,
        // DESKTOP LAYOUT: sticky within the left panel instead of fixed over full viewport
        [theme.breakpoints.up('md')]: {
          position: 'sticky',
          left: 'unset',
          right: 'unset',
          zIndex: 10,
        },
      })}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <Box
            component="img"
            src={logo}
            alt={name}
            sx={{
              height: 32,
              width: 'auto',
            }}
          />
          <Typography variant="body2" color="text.secondary">
            {title}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {showFilter && (
            <IconButton
              size="small"
              onClick={onFilterClick}
              // Só ganha cor com filtro ativo; sem filtro, cor padrão do IconButton.
              color={hasActive ? 'primary' : 'default'}
            >
              <Badge
                badgeContent={activeFilterCount}
                color="secondary"
                overlap="circular"
                invisible={!hasActive}
              >
                <FilterIcon />
              </Badge>
            </IconButton>
          )}
          {/* Botões de ícone extras da página (ex.: menu de ações), à direita do filtro. */}
          {actions}
        </Box>
      </Box>

      {/* Search Bar - integrado no TopBar */}
      {showSearch && (
        <Stack spacing={1.5} mt={2}>
          <SearchField onSearch={onSearch} placeholder={searchPlaceholder} />
          {searchFooter}
        </Stack>
      )}
    </Box>
  );
};

export default TopBar;
